export const phoneRegex = "[(]?([0-9]{3})[)]?[-.]?([0-9]{3})[-.]?([0-9]{4})";
export const emailRegex = `[\\w.-]+@([\\w-]+\\.)+[\\w-]{2,4}`;
export const zipRegex = `[0-9]{5}`;
export const cityRegex = `[a-zA-Z',-.\\s]{1,50}`;
export const genericRegex = `\\w[\\w.\\-#&'.\\s]*`;
export const optionEmailRegex = "^$|^[^\\s]+@[^\\s]+\\.[^\\s]+$";
